<template>
  <div>
    <b-card no-header>
      <form>
        <app-motivo
          label="Motivo"
          :nombre="cancelacionMotivoNombre"
          :labelCols="labelCols"
          :valido="cancelacionMotivoValido"
          :lista="cancelacionesMotivosList"
          :msjInvalido="cancelacionMotivoInvalidoMsj"
          @validate="validate"
          @updated="cancelacionMotivoActualizado">
        </app-motivo>  

        <b-form-group
          description="Aclaraciones sobre el motivo de la cancelación">
          <b-form-textarea
            id="observaciones"
            v-model="$v.observaciones.$model" 
            rows="5"
            max-rows="5"
            :state="observacionesValidas"
            @blur.native="validate">
          </b-form-textarea>
          <b-form-invalid-feedback id="observacionesFeedback">
            {{ observacionesInvalidasMsj }}
          </b-form-invalid-feedback>          
        </b-form-group>
      </form>
      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="save">Grabar</b-button>
        <b-button size="sm" variant="danger" class="footer-button" 
          @click.prevent="cancelar">Cancelar</b-button>
      </div>
    </b-card>

    <mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </mensaje>
  </div>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators';
import Motivo from '../shared/abmSelect.vue';
import Mensaje from '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'

export default {
  name: 'Cancelacion',
  components: {
    appMotivo: Motivo,
    Mensaje
  },
  mixins: [ 
    msjModal 
  ],
  data () {
    return {
      cancelacionMotivo: null,
      observaciones: '',

      noValidar: true,
      cancelacionMotivoValido: null,
      cancelacionMotivoInvalidoMsj: '',
      observacionesValidas: null,
      observacionesInvalidasMsj: '',

      cancelacionesMotivos: [],
      cancelacionesMotivosList: [],

      labelCols: 2,
    }
  },
  computed: {
    cancelacionMotivoNombre() {
      if (this.cancelacionMotivo) {
        if (this.cancelacionMotivo.nombre) {
          return this.cancelacionMotivo.nombre.trim();
        }
      }
      return null;
    },
  },
  created() {
    this.getDatosAdicionales();
  },  
  methods: {
    getDatosAdicionales() {
      let vm = this;

      vm.$store.dispatch('cancelacionesmotivos/getList')
        .then(() => {
          vm.cancelacionesMotivos = this.$store.getters['cancelacionesmotivos/list'];
          vm.cancelacionesMotivosList = this.$store.getters['cancelacionesmotivos/selectList'];
        })
        .catch(() => {
          this.modalOkAction = null;
          this.modalHiddenAction = null;
          this.modalMensaje = "Se produjo un error al recuperar la información de clientes.";
          this.modalMsj = true;
          this.loadingClientes= false;
        });
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar){
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }
      
      if (campo == 'observaciones' || validarTodos) {
        if (this.$v.observaciones.$error) {
          this.observacionesValidas = false;
          if (!this.$v.observaciones.maxLength) {
            this.observacionesInvalidasMsj = 'Las observaciones solo pueden contener hasta 5000 caracteres';
          }      
        } else {
          this.observacionesValidas = null;
          this.observacionesInvalidasMsj = '';
        }
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;


      this.$v.$touch();

      let save = Boolean(false);
      let errorCancelacionMotivo = Boolean(false);
      if (this.cancelacionMotivo) {
        if (this.cancelacionMotivo.id) {
          if (this.cancelacionMotivo.id != 0) {
            save = Boolean(true);
          }
        }
      }
      if (errorCancelacionMotivo) {
        this.cancelacionMotivoValido = false;
        this.cancelacionMotivoInvalidoMsj = "Debe seleccionar el motivo correspondiente.";
      }

      if (save) {
        if (this.$v.$anyError) {
          this.displayErrores();
        } else {
          let params = {
            cancelacionMotivoId: this.cancelacionMotivo.id,
            observaciones: this.observaciones.trim(),
          }
          this.$emit('cancelarPresupuesto', params)
        }
      }
    },
    cancelar() {
      this.$emit('cancelarCancelacion')
    },
    cancelacionMotivoActualizado(cancelacionMotivoNombre) {
      this.cancelacionMotivo = this.getSelected(this.cancelacionesMotivos, cancelacionMotivoNombre);
      
      this.cancelacionMotivoValido = null;
      this.cancelacionMotivoInvalidoMsj = '';
    },
  },
  validations: {
    observaciones: {
      maxLength: maxLength(5000)
    },
  },  
  watch: {
  }    
}
</script>

<style>
</style>
